/**
 * 包邮进度条动态更新逻辑
 * 监听购物车更新事件，实时更新包邮进度条
 */
(function() {
  'use strict';

  /**
   * 更新包邮进度条
   * @param {number} subtotal - 购物车小计金额（单位：分）
   */
  function updateFreeShippingBar(subtotal) {
    const freeShippingBars = document.querySelectorAll('.free-shipping-bar');
    
    if (freeShippingBars.length === 0) {
      return;
    }

    freeShippingBars.forEach((bar) => {
      const freeShippingAmount = parseFloat(bar.dataset.freeShippingAmount) || 0;
      
      // 计算免邮费进度 (0-1之间)
      const progress = Math.min(Math.max(subtotal / freeShippingAmount, 0), 1);
      
      // 计算还差多少钱
      const difference = Math.max(freeShippingAmount - subtotal, 0);
      
      // 更新进度条
      updateProgressBar(bar, progress);
      
      // 更新提示信息
      updateMessage(bar, progress, difference);
    });
  }

  /**
   * 更新进度条样式
   * @param {HTMLElement} bar - 进度条元素
   * @param {number} progress - 进度值 (0-1)
   */
  function updateProgressBar(bar, progress) {
    // 更新 CSS 变量
    bar.style.setProperty('--free-shipping-progress', progress.toString());
    
    // 更新数据属性
    bar.setAttribute('data-free-shipping-progress', progress === 1 ? '1' : progress.toString());
  }

  /**
   * 更新提示信息
   * @param {HTMLElement} bar - 进度条元素
   * @param {number} progress - 进度值 (0-1)
   * @param {number} difference - 还差多少钱（单位：分）
   */
  function updateMessage(bar, progress, difference) {
    const messageNo = bar.querySelector('.free-shipping-bar__message--no');
    const messageYes = bar.querySelector('.free-shipping-bar__message--yes');
    const differenceElement = bar.querySelector('#free-shipping-difference');
    
    if (progress >= 1) {
      // 已达到免邮费条件
      if (messageNo) messageNo.style.display = 'none';
      if (messageYes) messageYes.style.display = 'inline';
    } else {
      // 未达到免邮费条件
      if (messageNo) messageNo.style.display = 'inline';
      if (messageYes) messageYes.style.display = 'none';
      
      // 更新还差多少钱的显示
      if (differenceElement && typeof theme !== 'undefined' && theme.Currency) {
        differenceElement.innerHTML = theme.Currency.formatMoney(difference, theme.settings.moneyFormat);
      }
    }
  }

  /**
   * 从购物车 API 获取最新数据并更新进度条
   */
  function fetchCartAndUpdate() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        if (cart && cart.total_price !== undefined) {
          updateFreeShippingBar(cart.total_price);
        }
      })
      .catch(error => {
        console.error('Failed to fetch cart data:', error);
      });
  }

  /**
   * 监听购物车更新事件（购物车内修改数量、删除商品）
   */
  document.addEventListener('cart:updated', function(event) {
    if (event.detail && event.detail.cart) {
      // 从购物车对象中获取总价
      const subtotal = event.detail.cart.total_price || 0;
      updateFreeShippingBar(subtotal);
    }
  });

  /**
   * 监听加购事件（添加商品到购物车）
   */
  document.addEventListener('ajaxProduct:added', function(event) {
    // 加购后重新获取购物车数据并更新进度条
    fetchCartAndUpdate();
  });

  /**
   * 页面加载时初始化（如果购物车已经有内容）
   */
  document.addEventListener('DOMContentLoaded', function() {
    // 如果页面上有购物车信息，尝试获取并更新
    if (typeof cart !== 'undefined' && cart.total_price !== undefined) {
      updateFreeShippingBar(cart.total_price);
    }
  });

})();
